import { render } from "./TableViews.vue?vue&type=template&id=c5f310d6&scoped=true"
import script from "./TableViews.vue?vue&type=script&lang=js"
export * from "./TableViews.vue?vue&type=script&lang=js"

import "./TableViews.vue?vue&type=style&index=0&id=c5f310d6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c5f310d6"]])

export default __exports__